/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  SearchPanel,
  Toolbar,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { getRowId, updateDocNumbers } from '../../common';
import { useLazyQuery } from '@apollo/client';

import {
  currencyFormatter,
  samllFormatter,
  timeFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { Box, Button, Typography } from '@material-ui/core';
import { TableComponent } from '../../Shared/TableComponent';
import { useTemplate } from '../../hooks';
import getOpeningBalances from '../../graphql/query/getOpeningBalances';
import { getColumns } from '../constants/columns';

const FinanceBalances = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end, pageSize, setPageSize } = props;
  const [custfilter, setCustfilter] = useState(false);
  const [suppfilter, setSuppfilter] = useState(false);
  const [accfilter, setAccfilter] = useState(false);

  const col = getColumns({ isRTL, words });

  const [columns] = useState([
    { name: '', title: '' },
    { name: 'time', title: words?.time },
    { name: 'docNo', title: words?.no },
    col.customer,
    col.supplier,
    col.account,
    { name: 'amount', title: words?.amount },
    { name: 'desc', title: words?.description },
  ]);

  const [tableColumnExtensions]: any = useState([
    { columnName: '', width: 70 },
    { columnName: 'time', width: 150 },
    { columnName: 'docNo', width: 150 },
    { columnName: col.customer.name, width: 250 },
    { columnName: col.supplier.name, width: 250 },
    { columnName: col.account.name, width: 250 },
    { columnName: 'desc', width: 400 },
    { columnName: 'amount', width: 150 },
  ]);

  const [tableColumnVisibilityColumnExtensions] = useState([
    { columnName: 'time', togglingEnabled: false },
  ]);

  const [rows, setRows] = useState([]);

  const [loadFinances, financeData]: any = useLazyQuery(getOpeningBalances, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
    };
    if (start) {
      loadFinances({
        variables,
      });
    }
  }, [start, end]);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (financeData?.refetch) {
        financeData.refetch();
      }
    },
  }));

  const { tempoptions } = useTemplate();

  useEffect(() => {
    if (financeData?.data?.getOpeningBalances?.data) {
      const { data } = financeData.data.getOpeningBalances;
      const rdata = updateDocNumbers(data);
      let fdata = rdata;
      if (custfilter) {
        fdata = fdata.filter((da: any) => da.customerId);
      }
      if (suppfilter) {
        fdata = fdata.filter((da: any) => da.supplierId);
      }
      if (accfilter) {
        fdata = fdata.filter((da: any) => da.accountId);
      }
      setRows(fdata);
    }
  }, [financeData, custfilter, suppfilter, accfilter]);

  return (
    <>
      <Box
        display="flex"
        style={{
          position: 'absolute',
          zIndex: 111,
          flexDirection: 'row',
          alignItems: 'center',
          top: 55,
          right: isRTL ? 500 : undefined,
          left: isRTL ? undefined : 500,
        }}
      >
        <Box style={{ display: 'flex', marginLeft: 50, marginRight: 50 }}>
          <Button
            color="primary"
            variant={custfilter ? 'contained' : 'outlined'}
            onClick={() => {
              setCustfilter(!custfilter);
              setSuppfilter(false);
              setAccfilter(false);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'العملاء' : 'Customers'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={suppfilter ? 'contained' : 'outlined'}
            onClick={() => {
              setSuppfilter(!suppfilter);
              setCustfilter(false);
              setAccfilter(false);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'الموردين' : 'Suppliers'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={accfilter ? 'contained' : 'outlined'}
            onClick={() => {
              setAccfilter(!accfilter);
              setCustfilter(false);
              setSuppfilter(false);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'الحسابات' : 'Accounts'}
            </Typography>
          </Button>
        </Box>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <SearchState />
        <PagingState
          pageSize={pageSize ? pageSize : 10}
          onPageSizeChange={setPageSize ? setPageSize : () => null}
          defaultCurrentPage={0}
          defaultPageSize={10}
        />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 60 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          columnExtensions={tableColumnVisibilityColumnExtensions}
          defaultHiddenColumnNames={[]}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['amount']}
          formatterComponent={currencyFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['docNo', 'refNo']}
          formatterComponent={samllFormatter}
        ></DataTypeProvider>
        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
          }
        />
        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
      </Grid>
    </>
  );
});

export default FinanceBalances;
